import {
    SxProps,
    Theme,
    Typography,
    TypographyProps,
    useMediaQuery,
    useTheme,
} from '@rhg/libs/material';
import { useMemo } from 'react';

interface SimpleDialogTitleProps {
    title?: string;
    titleVariant?: TypographyProps['variant'];
    titleTextAlign?: TypographyProps['textAlign'];
    titleColor?: TypographyProps['color'];
    titleId?: string;
    sx?: SxProps<Theme>;
}
export const SimpleDialogTitle = ({
    title = '',
    titleVariant,
    titleTextAlign = 'center',
    titleColor = 'text.primary',
    titleId,
    sx,
}: SimpleDialogTitleProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const computedTitleVariant = useMemo(
        () => titleVariant ?? (isMobile ? 'h5' : 'h4'),
        [isMobile, titleVariant]
    );

    return (
        <Typography
            id={titleId}
            variant={computedTitleVariant}
            component="h2"
            color={titleColor}
            textAlign={titleTextAlign}
            sx={sx}
        >
            {title}
        </Typography>
    );
};
